import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { SIZES } from './button';
import { Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

export const AlreadyInOrderAction = () => {
  const [styles] = useStyles();
  return (
    <View style={styles.alreadyInOrder}>
      <Text style={[TYPOGRAPHY.pSemiBold, styles.alreadyInOrderText]}>
        {i18n.t('item_already_in_order')}
      </Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  alreadyInOrder: {
    height: SIZES.small,
    justifyContent: 'center',
  },
  alreadyInOrderText: {
    color: theme.colors.inactiveText,
  },
}));
